import API, { defaultHeaders, IRI } from '@/api';

const meEdit = async payload => {
  const {
    headers = {},
    body = {},
  } = payload;

  Object.assign(headers, defaultHeaders);
  headers.Authorization = `Bearer ${sessionStorage.getItem('token')}`;

  return fetch(`${API}/${IRI.me}`, {
    headers,
    method: 'PUT',
    body: JSON.stringify(body),
  });
};

export default meEdit;
